import axiosInstance from "../../axiosInstance";

// Use environment variable for API URL, with a fallback for development
// const base = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
// const BASE_URL = `${base}/branches`;

const BASE_URL = "/hrm/branches";

/** Thống kê mini dashboard (không lọc) */
export const getBranchStatsSummary = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/stats/summary`);
    return res.data;
  } catch (error) {
    console.error("Error fetching branch stats:", error);
    throw error;
  }
};

// Lấy danh sách tất cả chi nhánh (có thể truyền query lọc)
export const getAllBranches = async (params = {}) => {
    try {
      const res = await axiosInstance.get(BASE_URL, { params });
      return res.data;
    } catch (error) {
      console.error('Error fetching branches:', error);
      throw error;
    }
};

// 📁 src/api/hrm/branches/info.js
export const getAllBranches_Array = async (params = {}) => {
    try {
      const res = await axiosInstance.get(BASE_URL, { params });
  
      // ✅ Bóc dữ liệu ra đúng dạng mảng
      if (Array.isArray(res.data)) return res.data;
      if (Array.isArray(res.data.items)) return res.data.items;
      if (Array.isArray(res.data.data)) return res.data.data;
      return [];
    } catch (error) {
      console.error("Error fetching branches:", error);
      return [];
    }
};
  


// Lấy thông tin 1 chi nhánh theo ID
export const getBranchById = async (id) => {
    const response = await axiosInstance.get(`${BASE_URL}/${id}`);
    return response.data;
};

// Thêm mới chi nhánh
export const createBranch = async (data) => {
    const response = await axiosInstance.post(BASE_URL, data);
    return response.data;
};

// Cập nhật chi nhánh
export const updateBranch = async (id, data) => {
    const response = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return response.data;
};

// Xóa chi nhánh
export const deleteBranch = async (id) => {
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
};